export const DEFAULT_ERROR = 0;
export const CONNECTIVITY_ERROR = 1;
export const SERVER_ERROR = 2;
